module.exports = __webpack_public_path__ + "img/icon-code-lines.5b661b08.svg";